/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_InboundShareTransfer_InboundShareTransferSampleDownloadResponse } from '../models/Wealthlane_AwardService_Dtos_InboundShareTransfer_InboundShareTransferSampleDownloadResponse';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InboundShareTransferService {

    /**
     * @param formData
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppInboundShareTransferImportInboundShareTransfer(
        formData?: {
            File?: Blob;
        },
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/inbound-share-transfer/import-inbound-share-transfer',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_InboundShareTransfer_InboundShareTransferSampleDownloadResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppInboundShareTransferDownloadInboundShareTransferTemplate(): CancelablePromise<Wealthlane_AwardService_Dtos_InboundShareTransfer_InboundShareTransferSampleDownloadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/inbound-share-transfer/download-inbound-share-transfer-template',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_InboundShareTransfer_InboundShareTransferSampleDownloadResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppInboundShareTransferExportInboundShare(): CancelablePromise<Wealthlane_AwardService_Dtos_InboundShareTransfer_InboundShareTransferSampleDownloadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/inbound-share-transfer/export-inbound-share',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
